module.exports = __webpack_public_path__ + "static/hero_home-605f1929c8153d22a505b8cdd93b6df5.svg";